import React from "react";
import { DebouncedInput } from "../../Constant/common";
import { All } from "../../Constant";

const CustomPagination = ({
  pageSize,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
  onNextPage,
  children,
  onPreviousPage,
  onPageSizeChange,
  searchQuery,
  onSearchChange,
  defaultPageSize,
}) => {
  const startIndex = pageSize && (currentPage - 1) * pageSize + 1;
  const endIndex = totalRecords && pageSize && Math.min(currentPage * pageSize, totalRecords);

  const renderPages = () => {
    const MAX = 5;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + MAX - 1);
    if (end - start + 1 < MAX) start = Math.max(1, end - MAX + 1);

    const items = [];
    if (start > 1)
      items.push(
        <li key="s-ellipsis" className="page-item disabled">
          <span className="page-link">…</span>
        </li>,
      );

    for (let i = start; i <= end; i++) {
      items.push(
        <li key={i} className={`page-item${currentPage === i ? " active" : ""}`}>
          <a
            href="#!"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              onPageChange(i);
            }}
          >
            {i}
          </a>
        </li>,
      );
    }

    if (end < totalPages)
      items.push(
        <li key="e-ellipsis" className="page-item disabled">
          <span className="page-link">…</span>
        </li>,
      );

    return items;
  };

  return (
    <div>
      {/* Top controls */}
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
        <div
          className="d-flex align-items-center gap-2"
          style={{ fontSize: "0.8125rem", color: "var(--text-secondary)" }}
        >
          <span>Rows per page:</span>
          <select
            onChange={onPageSizeChange}
            value={pageSize ?? defaultPageSize}
            className="form-select"
            style={{ width: "auto", padding: "5px 28px 5px 10px" }}
          >
            {[5, 10, 25, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
            <option value={All}>{All}</option>
          </select>
        </div>
        <div style={{ minWidth: 200 }}>
          <DebouncedInput
            placeholder="Search…"
            value={searchQuery}
            onChange={onSearchChange}
            className="form-control"
          />
        </div>
      </div>

      {children}

      {/* Bottom pagination */}
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3 pb-2">
        {startIndex > 0 && endIndex > 0 && (
          <span style={{ fontSize: "0.8125rem", color: "var(--text-muted)" }}>
            Showing{" "}
            <strong style={{ color: "var(--text-primary)" }}>
              {startIndex}–{endIndex}
            </strong>{" "}
            of <strong style={{ color: "var(--text-primary)" }}>{totalRecords}</strong>
          </span>
        )}
        <ul className="pagination mb-0">
          <li className={`page-item${currentPage === 1 ? " disabled" : ""}`}>
            <a
              href="#!"
              className="page-link"
              onClick={(e) => {
                e.preventDefault();
                onPreviousPage();
              }}
              aria-label="Previous"
            >
              <i className="fa fa-chevron-left" />
            </a>
          </li>
          {renderPages()}
          <li className={`page-item${currentPage === totalPages ? " disabled" : ""}`}>
            <a
              href="#!"
              className="page-link"
              onClick={(e) => {
                e.preventDefault();
                onNextPage();
              }}
              aria-label="Next"
            >
              <i className="fa fa-chevron-right" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CustomPagination;
